import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import AffidavitListItem from './AffidavitListItem';

function AffidavitListItems({ items, onDelete, onPrint }) {
  return (
    <>
      {items.map((item) => (
        <Box className="affidavit-list-items">
          <Typography
            className="affidavit-list-items-title"
          >
            {item.title}
          </Typography>
          {item.affidavits && item.affidavits.length > 0 ? (
            item.affidavits.map((affidavit, index) => (
              <React.Fragment key={affidavit.affidavit_id}>
                <AffidavitListItem
                  item={affidavit}
                  onDelete={onDelete}
                  onPrint={onPrint}
                />
              </React.Fragment>
            ))
          ) : (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography color="text.secondary">
                No affidavits found
              </Typography>
            </Box>
          )}
        </Box>
      ))}
    </>
  );
}

export default AffidavitListItems; 